<template>
	<div class="quick-reply-container">
		<form action="javascript:;" class="quick-reply-head">
			<el-select v-model="type" placeholder="请选择">
				<el-option v-for="obj in searchTypeList" :key="obj.key" :label="obj.label" :value="obj.key"></el-option>
			</el-select>
			<input type="text" class="text" placeholder="搜索常用回复" v-model="searchText" />
			<input type="button" value="搜索" class="button" @click="clickSearch" />
		</form>

		<div class="quick-reply-list">
			<template v-if="quickReplyList.length">
				<dl v-for="(typeObj, typeKey) in quickReplyList" :class="{furl: !typeObj.open}"><dt @click="typeObj.open = !typeObj.open">{{ typeObj.name }}</dt>
					<dd v-for="(replyObj, replyKey) in typeObj.replyList" @click="addToSendContent(replyObj.replytext, $event)">
						<span class="reply-name" :title="replyObj.quicktext">{{ replyObj.quicktext }}</span>
						<p class="reply-text" :title="replyObj.replytext" :style="{'margin-right': (type ? 'auto' : '-15px')}">{{ replyObj.replytext }}</p>
						<a v-if="type" href="javascript:;" class="del-btn" @click="delQuickReply(typeKey, replyKey)"></a>
					</dd>
				</dl>
			</template>
			<p v-else class="shift" style="margin: 0 10px">没有数据</p>
		</div>

		<ul class="quick-reply-bottom">
			<li>
				<a class="edit-concluding-remarks" href="javascript:;" @click="getConcludingRemarks">结束语</a>
			</li>
			<li>
				<input type="button" value="添加" class="button gray" @click="showAddModal"/>
			</li>
			<li>
				<input type="button" value="清空个人" class="button gray" @click="deleteAllQuickReply" />
			</li>
			<li>
				<label class="button import">
					<span>导入</span>
					<input class="js-send-pic" accept="application/vnd.ms-excel" type="file" @change="importReply">
				</label>
			</li>
		</ul>

		<el-dialog title="添加新回复" :visible.sync="showAddBox" custom-class="im-modal width-normal">
			<el-form :model="addForm" :rules="addRules" ref="addFormBox">
				<el-form-item label="选择类别：" :label-width="formLabelWidth" prop="typeid">
					<el-select v-model="addForm.typeid" placeholder="请选择类别">
						<el-option v-for="o in typeList" :key="o.id" :label="o.name" :value="o.id"></el-option>
					</el-select>
					<el-button type="primary" @click="showAddQuickReplyType">添加类别</el-button>
				</el-form-item>
				<el-form-item label="快捷词：" :label-width="formLabelWidth" prop="quicktext">
					<el-input v-model="addForm.quicktext" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="回复内容：" :label-width="formLabelWidth" prop="replytext">
					<el-input v-model="addForm.replytext" auto-complete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="showAddBox = false">取 消</el-button>
				<el-button type="primary" @click="submitAddQuickReply()">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="添加类别" :visible.sync="showAddTypeBox" custom-class="im-modal width-normal add-qr-type-modal">
			<el-form>
				<template v-for="(o, index) in modalTypeList">
					<el-form-item>
						<el-input v-model="o.name" auto-complete="off" :disabled="!o.edit"></el-input>
						<el-button v-if="o.edit" type="primary" @click="saveType(o)">保 存</el-button>
						<el-button v-else type="primary" @click="editType(index)">修 改</el-button>
						<el-button @click="delType(o)">删 除</el-button>
					</el-form-item>
				</template>
				<el-form-item>
					<el-input v-model="newTypeValue" auto-complete="off"></el-input>
					<el-button type="primary" @click="saveType({'name': newTypeValue})">保 存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<div v-show="showConcludingRemarks" class="concluding-remarks-box">
			<el-checkbox v-model="enableConcludingRemarks">启用结束语</el-checkbox> <span class="ps">启用后超过指定时间未接收到新消息将会自动发送结束语</span>
			<textarea placeholder="请输入结束语内容" :disabled="!enableConcludingRemarks" v-model="concludingRemarksContent"></textarea>
			<span class="content-error">{{ concludingRemarksContentError }}</span>
			<p class="time-box">发送时间：<input class="text" type="text" value="" :disabled="!enableConcludingRemarks" v-model="concludingRemarksTime"> 分钟　(必须大于等于5分钟)</p>
			<span class="time-error">{{ concludingRemarksTimeError }}</span>
			<div class="btn-box clear">
				<a href="javascript:;" class="button gray pull-left" @click="showConcludingRemarks = false">取消</a>
				<a href="javascript:;" class="button pull-right" @click="saveConcludingRemarks">保存</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'quickReplyTpl',
	data () {
		return {
			searchSwitch: true,
			setImKey: 'SETIM',
			qRKey: 'QuickReply-',
			open: false,
			searchText: '',
			type: 1,
			searchTypeList: [
				{
					key: 1,
					label: '个人'
				},
				{
					key: 0,
					label: '团队'
				}
			],
			quickReplyList: [],
			showAddBox: false,
			formLabelWidth: '100px',
			typeList: [],
			addForm: {
				typeid: '',
				quicktext: '',
				replytext: ''
			},
			addRules: {
				typeid: [
					{required: true, message: '请选择类别', trigger: 'change'}
				],
				quicktext: [
					{required: true, message: '请输入快捷词', trigger: 'blur'}
				],
				replytext: [
					{required: true, message: '请输入回复内容', trigger: 'blur'}
				]
			},
			showAddTypeBox: false,
			modalTypeList: [],
			newTypeValue: '',
			enableConcludingRemarks: false,
			showConcludingRemarks: false,
			concludingRemarksId: null,
			concludingRemarksContent: '',
			concludingRemarksTime: '',
			concludingRemarksContentError: '',
			concludingRemarksTimeError: ''
		}
	},
	computed: {
		currentShop () {
			return this.$store.state.currentShop;
		}
	},
	watch: {
		currentShop: {
			deep: true,
			handler (now, old) {
				var self = this;

				if (now.id == old.id || !now.id) return;
				self.clickShop();
			}
		},
		type () {
			var self = this;

			if (!self.searchSwitch) return;

			var setJson = localStorage.getItem(self.setImKey) ? JSON.parse(localStorage.getItem(self.setImKey)) : {};
			self.open = setJson.allQrStretch;
			self.searchQuickReply();
		}
	},
	methods: {
		// 点击店铺
		clickShop () {
			var self = this,
				setJson = localStorage.getItem(self.setImKey) ? JSON.parse(localStorage.getItem(self.setImKey)) : {};

			self.searchSwitch = false;
			self.type = 1;
			self.searchText = '';
			self.open = setJson.allQrStretch;
			self.searchSwitch = true;

			self.searchQuickReply();
		},

		// 点击查询按钮
		clickSearch () {
			var self = this;

			self.open = true;
			self.searchQuickReply();
		},

		// 搜索快捷回复
		searchQuickReply () {
			var self = this,
				shopId = self.currentShop.id,
				key = self.qRKey + shopId,
				json = null;

			if (sessionStorage.getItem(key)) {
				json = JSON.parse(sessionStorage.getItem(key));
				self.handleQuickReply(json);

			} else {
				var data = {
						shopId: shopId
					};

				self.$axios.post(API_ROOT.url + '/CommonReplyApi.searchReply', data).then(result => {
					if (result.status) {
						sessionStorage.setItem(key, JSON.stringify(result.data));
						// 防止获取到数据时已经切换到其他店铺了
						if (self.currentShop.id != data.shopId) return;
						self.handleQuickReply(result.data);
					} else {
						self.$alert('获取快捷回复数据失败，失败原因：' + result.msg);
					}

				}, response => {
					self.quickReplyList = [];
					self.$alert('获取快捷回复数据失败，错误码(' + response + ')');
				})
			}
		},

		// 对搜索出来的数据进行处理
		handleQuickReply (json) {
			var self = this,
				typeArr = json.typeList,
				searchText = self.searchText.trim();

			if(typeArr && !typeArr.length){
				self.quickReplyList = [];
				return;
			}

			for (var i = typeArr.length - 1; i >= 0; i--) {
				if (!typeArr[i].replyList || typeArr[i].type != self.type) {
					typeArr.splice(i, 1);
					continue;
				}

				typeArr[i].open = self.open;

				if (searchText) {
					for (var j = typeArr[i].replyList.length - 1; j >= 0; j--) {
						var dataObj = typeArr[i].replyList[j];

						// 如果搜索内容不为空，判断该条回复是否包含搜索内容，如果不包含，删除该条数据
						if (dataObj.quicktext.indexOf(searchText) == -1 && dataObj.replytext.indexOf(searchText) == -1) {
							typeArr[i].replyList.splice(j, 1);
						}
					}
				}

				if (!typeArr[i].replyList.length) typeArr.splice(i, 1);
			}

			self.quickReplyList = typeArr;
		},

		// 点击快捷回复添加到发送框
		addToSendContent(content, e) {
			var self = this;

			if (e.target.className == 'del-btn' || !self.$store.state.conversationList.length) return;
			self.$store.commit('changeSendContent', content);
			document.getElementsByClassName('ima_textarea')[0].focus();
		},
			
		// 删除快捷回复
		delQuickReply (typeKey, replyKey) {
			var self = this,
				obj = self.quickReplyList[typeKey].replyList[replyKey],
				shopId = self.quickReplyList[typeKey].shopId,
				data = {
					id: obj.id
				};
			
			if (obj.pendingClose) return;
			
			self.$confirm('你确定要删除该数据？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				obj.pendingClose = true;
				self.$axios.post(API_ROOT.url + '/CommonReplyApi.deleteReply', data).then(result => {
					var nowObj = self.quickReplyList[typeKey].replyList[replyKey];
					if (nowObj.id == data.id) self.quickReplyList[typeKey].replyList[replyKey].pendingClose = false;

					if (result.status) {
						var key = self.qRKey + shopId;
						sessionStorage.removeItem(key);
						self.$alert("删除成功！");
						self.clickSearch();
					} else {
						self.$alert('删除快捷回复失败，失败原因：' + result.msg);
					}
				}, response => {
					var nowObj = self.quickReplyList[typeKey].replyList[replyKey];
					if (nowObj.id == data.id) self.quickReplyList[typeKey].replyList[replyKey].pendingClose = false;
					self.$alert('删除快捷回复失败，错误码(' + response + ')');
				});
			}).catch(() => {
			});
		},

		// 清空个人快捷回复
		deleteAllQuickReply () {
			var self = this,
				data = {
					shopId: self.currentShop.id
				};

			self.$confirm('是否确定清空个人所有常用回复？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				self.$axios.post(API_ROOT.url + '/CommonReplyApi.deleteAllReplyType', data).then(result => {
					if (result.status) {
						var key = self.qRKey + data.shopId;
						sessionStorage.removeItem(key);
						self.$alert("删除成功！");
						self.clickSearch();
					} else {
						self.$alert('清空个人所有常用回复失败，失败原因：' + result.msg);
					}
				}, response => {
					self.$alert('清空个人所有常用回复失败，错误码(' + response + ')');
				});
			}).catch(() => {
			});
		
		},

		// 显示添加快捷回复模版
		showAddModal () {
			var self = this,
				data = {
					shopId: self.currentShop.id,
					typeid: 1
				};

			self.showAddBox = true;

			try {
				self.$refs['addFormBox'].resetFields();
			} catch (e) {}

			self.$axios.post(API_ROOT.url + '/CommonReplyApi.getReplyByType', data).then(result => {
				if (result.status) {
					self.typeList = result.data;
				} else {
					self.$alert('获取快捷回复类别失败，失败原因：' + result.msg);
				}
			}, response => {
				self.$alert('获取快捷回复类别失败，错误码(' + response + ')');
			});
		},

		// 提交新添加的快捷回复
		submitAddQuickReply () {
			var self = this,
				data = {
					commonReply: self.addForm
				},
				shopId = self.currentShop.id;

			data.commonReply.type = 1;
			data.commonReply.shopId = shopId;

			self.$refs['addFormBox'].validate((valid) => {
				if (!valid) return;

				self.$axios.post(API_ROOT.url + '/CommonReplyApi.saveReply', data).then(result => {
					if (result.status) {
						self.showAddBox = false;
						var key = self.qRKey + shopId;
						sessionStorage.removeItem(key);
						self.clickSearch();
					} else {
						self.$alert('添加快捷回复失败，失败原因：' + result.msg);
					}
				}, response => {
					self.$alert('添加快捷回复失败，错误码(' + response + ')');
				});
			});
		},

		// 显示添加快捷回复类别模版
		showAddQuickReplyType () {
			var self = this;
			self.modalTypeList = JSON.parse(JSON.stringify(self.typeList));
			self.newTypeValue = '';
			self.showAddTypeBox = true;
		},

		// 修改类别
		editType (key) {
			var self = this,
				obj = self.modalTypeList[key];

			obj.edit = true;
			self.$set(self.modalTypeList, key, obj);
		},

		// 删除类别
		delType (obj) {
			var self = this,
				data = {
					id: obj.id,
					shopId: self.currentShop.id
				}

			self.$axios.post(API_ROOT.url + '/CommonReplyApi.deleteReplyType', data).then(result => {
				if (result.status) {
					self.$alert('删除成功');
					self.showAddTypeBox = false;
					self.typeList = result.data;
					var key = self.qRKey + data.shopId;
					sessionStorage.removeItem(key);
					self.clickSearch();
				} else {
					self.$alert('删除快捷回复类别失败，失败原因：' + result.msg);
				}
			}, response => {
				self.$alert('删除快捷回复类别失败，错误码(' + response + ')');
			});
		},

		// 保存类别
		saveType (obj) {
			var self = this,
				data = {
					commonReplyType: {
						shopId: self.currentShop.id,
						name: obj.name
					}
				};

			if (obj.id) data.commonReplyType.id = obj.id;
			if (!obj.name.trim()) {
				self.$alert('请先填写内容');
				return;
			}
			self.$axios.post(API_ROOT.url + '/CommonReplyApi.saveReplyType', data).then(result => {
				if (result.status) {
					self.$alert('保存成功');
					self.showAddTypeBox = false;
					self.typeList = result.data;
				} else {
					self.$alert('保存快捷回复类别失败，失败原因：' + result.msg);
				}
			}, response => {
				self.$alert('保存快捷回复类别失败，错误码(' + response + ')');
			});
		},

		// 导入快捷回复
		importReply (e) {
			if (!e.target.value) return;
			var self = this,
				shopId = self.currentShop.id,
				uploadUrl = API_ROOT.uploadUrl + '/raw/reply/importReply?shopId=' + shopId,
				formData = new FormData(),
				file = e.target.files[0],
				filename = file.name;

			formData.append('file', file);
			$('.js-send-pic').val('').prop('disabled', true);
			$('.js-send-pic').parent().addClass('load');

			$.ajax({
				url: uploadUrl,
				data: formData,
				type: 'post',
				processData: false,
				contentType: false,
				dataType: 'json',
				xhrFields: {
					withCredentials: true
				},
				success: function (result) {
					$('.js-send-pic').prop('disabled', false);
					$('.js-send-pic').parent().removeClass('load');
					if (result.status) {
						if (shopId != self.currentShop.id) return;
						var key = self.qRKey + shopId;
						sessionStorage.removeItem(key);
						self.clickSearch();
					} else {
						self.$alert('导入快捷回复失败');
					}
				},
				error: function (xOptions, textStatus) {
					$('.js-send-pic').prop('disabled', false);
					$('.js-send-pic').parent().removeClass('load');
					self.$alert('导入快捷回复失败');
				}
			});
		},

		// 获取结束语配置信息
		getConcludingRemarks () {
			var self = this,
				data = {
					shopId: self.currentShop.id,
					customerId: self.$store.state.userInfo.id
				};

			self.$axios.post(API_ROOT.url + '/IMConclusionApi.getByShopIdAndCustomerId', data).then(result => {
				if (result.status) {
					if (result.data) {
						self.enableConcludingRemarks = !!result.data.enable;
						self.concludingRemarksContent = result.data.text || '';
						self.concludingRemarksTime = result.data.sendDelay || '';
						self.concludingRemarksId = result.data.id || null;
					} else {
						self.enableConcludingRemarks = false;
						self.concludingRemarksContent = '';
						self.concludingRemarksTime = '';
						self.concludingRemarksId = null;
					}
					self.concludingRemarksContentError = '';
					self.concludingRemarksTimeError = '';
					self.showConcludingRemarks = true;
				} else {
					self.$alert('获取结束语配置信息失败，失败原因：' + result.msg);
				}
			}, response => {
				self.$alert('获取结束语配置信息失败，错误码(' + response + ')');
			});
		},

		// 保存结束语配置
		saveConcludingRemarks () {
			var self = this;

			if (self.enableConcludingRemarks && !self.concludingRemarksContent.trim()) {
				self.concludingRemarksContentError = '结束语不能为空';
			} else {
				self.concludingRemarksContentError = '';
			}

			if (self.enableConcludingRemarks) {
				self.concludingRemarksTime = self.concludingRemarksTime + '';
				if (!self.concludingRemarksTime.trim()) {
					self.concludingRemarksTimeError = '时间不能为空';
				} else if (isNaN(self.concludingRemarksTime) || self.concludingRemarksTime*1 < 5) {
					self.concludingRemarksTimeError = '时间必须为大于等于5的数字';
				} else {
					self.concludingRemarksTimeError = '';
				}
			} else {
				self.concludingRemarksTimeError = '';
			}

			if (self.concludingRemarksContentError || self.concludingRemarksTimeError) return;

			var data = {
				shopId: self.currentShop.id,
				customerId: self.$store.state.userInfo.id,
				enable: self.enableConcludingRemarks,
				id: self.concludingRemarksId
			}
			if (data.enable) {
				data.sendDelay = self.concludingRemarksTime * 1;
				data.text = self.concludingRemarksContent;
			}
			self.$axios.post(API_ROOT.url + '/IMConclusionApi.saveOrUpdate', {imConclusion: data}).then(result => {
				if (result.status) {
					self.showConcludingRemarks = false;
					self.$alert('设置结束语成功');
				} else {
					self.$alert('设置结束语失败，失败原因：' + result.msg);
				}
			}, response => {
				self.$alert('设置结束语失败，错误码(' + response + ')');
			});
		}
	}
}
</script>

<style lang="less" scoped>
	.add-qr-type-modal {
		.el-input {
			width: 300px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/aside/quickReplyTpl.vue